import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LaunchIcon from '@mui/icons-material/Launch';
import { Accordion, AccordionSummary, Button, Divider, Stack, Typography } from '@mui/material';
import { colours } from '../../../StyleConstants';
import globusConnectPersonalAccount from '../../../images/globus-share/connect_personal_account.png';
import globusConnectPersonalLogin from '../../../images/globus-share/connect_personal_login.png';
import globusConnectPersonalSetup from '../../../images/globus-share/connect_personal_setup.png';
import LassoAccordionDetails from '../LassoAccordionDetails';

const openGlobusShareCollections = () => {
    window.open(window.env.globus.share_collections_url, '_blank', 'noopener,noreferrer');
}

const responsiveImage = {
    maxWidth: "562px",
    maxHeight: "500px",
    width: "100%",
    height: "100%",
    marginBlockStart: '.5rem'
};

const GlobusPersonalShareGuide = () => (
    <Stack gap={2}>
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step1-content" id="step1-header">
                <Typography fontWeight="500">1. Navigate to your Globus account to access the "Globus Connect Personal" download page.</Typography>
            </AccordionSummary>
            <Divider />
            <LassoAccordionDetails>
                <Button variant="primary" startIcon={<LaunchIcon />}
                    onClick={openGlobusShareCollections}>
                    Open Globus Personal Connect download page
                </Button>
            </LassoAccordionDetails>
        </Accordion>

        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step2-content" id="step2-header">
                <Typography fontWeight="500">2. Install the "Globus Connect Personal" client for your system.</Typography>
            </AccordionSummary>
            <Divider />
            <LassoAccordionDetails>
                <img
                    src={globusConnectPersonalAccount}
                    alt="Connect to globus - personal account"
                    style={responsiveImage} />
            </LassoAccordionDetails>
        </Accordion>

        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step3-content" id="step3-header">
                <Typography fontWeight="500">3. Login to your account using the Globus Connect Personal Application.</Typography>
            </AccordionSummary>
            <Divider />
            <LassoAccordionDetails>
                <img
                    src={globusConnectPersonalLogin}
                    alt="Connect to globus - personal login"
                    style={responsiveImage} />
            </LassoAccordionDetails>
        </Accordion>

        <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step3-content" id="step3-header">
                <Typography fontWeight="500">4. Set up a collection using Globus Connect Personal.</Typography>
            </AccordionSummary>
            <Divider />
            <LassoAccordionDetails>
                <Typography sx={{
                    color: colours.warning.warn
                }}
                >
                    IMPORTANT: Please leave the "High Assurance" option <strong>unchecked</strong>, as it is not required. Selecting this option will require additional institutional approval and may lead to unnecessary restrictions on your data access and transfer processes
                </Typography>
                <img
                    src={globusConnectPersonalSetup}
                    alt="Connect to globus - personal setup"
                    style={responsiveImage} />
            </LassoAccordionDetails>
        </Accordion>
    </Stack>
);

export default GlobusPersonalShareGuide;